import React, { Component } from "react";
import { Row, Col, Input, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import ReactDataGrid from 'react-data-grid';
import { Data, Toolbar } from 'react-data-grid-addons';
import { debounce } from 'lodash'
import axios from 'axios'
import { connect } from 'react-redux';
import { CUSTOMER_BUYER_URL } from "../../actions/url";
import { fetchCustomerBuyerList, deleteCustomerBuyer, editCustomerBuyer } from "../../actions/customers_actions";

class BuyerEditModal extends Component {
    constructor() {
        super();
        this.state = {
            buyer: {
                rows: [],
            },
            customerName: '',
            customer_id: '',
        }
    }

    componentDidMount() {
        if (this.props.customer) {
            this.setState({
                customerName: this.props.customer.Name,
                customer_id: this.props.customer.Customer_id,
            })
        }
        if (this.props.buyerList) {
            this.setState({
                buyer: { rows: this.props.buyerList },
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.buyerList != this.props.buyerList) {
            this.setState({
                buyer: { rows: nextProps.buyerList },
            })
        }
    }

    handleDeleteBounce = debounce((id) => {
        this.props.deleteCustomerBuyer(id, () => {
            alert('Delete Success');
            this.props.fetchCustomerBuyerList();
        })
    }, 200);

    handleEditBuyer = (row) => {
        let data = {
            FirstName: row.FirstName,
            Street: row.Street,
            State: row.State,
            City: row.City,
            Zip: row.Zip,
            AddressName: row.AddressName,
            Cellphone: row.Cellphone,
            Fax: row.Fax,
        }
        this.props.editCustomerBuyer(row.id, data, () => {
            alert('Edit Success');
            this.props.fetchCustomerBuyerList();
        });
    }

    render() {
        const getRows = () => Data.Selectors.getRows(this.state.buyer);
        const getSize = () => getRows().length;
        const handleGridSort = () => { }
        const rowGetter = (rowIdx) => {
            const rows = getRows();
            return rows[rowIdx];
        };
        const handleRowUpdated = (e) => {
            const rows = getRows();
            let row = rows[e.rowIdx];
            if (e.updated.FirstName != null) {
                if(!e.updated.FirstName) {
                    alert('FirstName required fields')
                    return
                }
                this.handleEditBuyer({ ...row, FirstName: e.updated.FirstName })
            } else if (e.updated.State != null) {
                this.handleEditBuyer({ ...row, State: e.updated.State })
            } else if (e.updated.Street != null) {
                this.handleEditBuyer({ ...row, Street: e.updated.Street })
            } else if (e.updated.Zip != null) {
                this.handleEditBuyer({ ...row, Zip: e.updated.Zip })
            } else if (e.updated.AddressName != null) {
                this.handleEditBuyer({ ...row, AddressName: e.updated.AddressName })
            } else if (e.updated.Cellphone != null) {
                this.handleEditBuyer({ ...row, Cellphone: e.updated.Cellphone })
            } else if (e.updated.Fax != null) {
                this.handleEditBuyer({ ...row, Fax: e.updated.Fax })
            } else {
                Object.assign(rows[e.rowIdx], e.updated);
            }
        }
        const columns = [
            {
                key: 'id',
                name: <Translate value="del" />,
                resizable: true,
                width: 40,
                getRowMetaData: row => row,
                formatter: ({ value }) => {
                    return <div>
                        <Button
                            onClick={() => {
                                this.handleDeleteBounce(value)
                            }}
                            bsStyle="danger"
                        >
                            x
                        </Button>
                    </div>
                },
            },
            {
                key: 'FirstName',
                name: <Translate value="buyer" />,
                resizable: true,
                width: 100,
                editable: true,
            },
            {
                key: 'State',
                name: <Translate value="state" />,
                resizable: true,
                width: 70,
                editable: true,
            },
            {
                key: 'Street',
                name: <Translate value="address" />,
                resizable: true,
                width: 180,
                editable: true,
            },
            {
                key: 'Zip',
                name: <Translate value="zip" />,
                resizable: true,
                width: 60,
                editable: true,
            },
            {
                key: 'AddressName',
                name: <Translate value="addressName" />,
                resizable: true,
                width: 100,
                editable: true,
            },
            {
                key: 'Cellphone',
                name: <Translate value="cellphone" />,
                resizable: true,
                width: 100,
                editable: true,
            },
            {
                key: 'Fax',
                name: <Translate value="fax" />,
                resizable: true,
                width: 100,
                editable: true,
            },
        ];
        return <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
            <ReactDataGrid
                rowKey="id"
                enableCellSelect={true}
                onGridSort={handleGridSort}
                onRowUpdated={handleRowUpdated}
                rowHeight={35}
                columns={columns}
                minHeight={300}
                rowGetter={rowGetter}
                rowsCount={getSize()}
            />
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        buyerList: state.customers.buyerList,
    }
}

const mapDispatchToProps = {
    fetchCustomerBuyerList,
    deleteCustomerBuyer,
    editCustomerBuyer,
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyerEditModal);


// WEBPACK FOOTER //
// ./master/jsx/components/Customers/BuyerEditModal.jsx